import { millisecondsInSecond } from "@suse-o11y/date-time";
import { max } from "@suse-o11y/max";

/**
 * Calculates the Frames Per Second interval (FPS) in ms.
 * FPS is how many frames are displayed per second.
 * If fps is 20, then 20 frames are displayed per second with an interval of 1000ms/20=50ms.
 *
 * @param frames - The number of frames to calculate the FPS for.
 * @returns The FPS interval in ms.
 */
export function msPerFrame(frames: number): number {
	return millisecondsInSecond / max(frames, 1);
}
